import type { ElementType } from 'react';

import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type RichTextProps = {
  /** HTML from the administration (editor or textbox) – never rendered as `{value}`. */
  html: string;
  /** Text style class from `typography.css`, e.g. `nt-body-l`. */
  variant: string;
  as?: ElementType;
  /**
   * `underline` = links in text/primary Heavy, `brand` = text/brand (green) without underline (FAQ
   * answers, notes), `inherit` = underlined in the colour and weight of the text (consent texts).
   */
  links?: 'underline' | 'brand' | 'inherit';
  /** `inverse` = white text on a dark, magenta or gradient surface: `<strong>` and links white too. */
  tone?: 'default' | 'inverse';
  className?: string;
};

/**
 * Admin text in an NT text style: `<strong>` and links in text/primary Heavy, ` <br>` from md.
 * A wrapping `<p>` from the editor keeps the style (`[&_p]:[font:inherit]`).
 */
export function RichText({
  html,
  variant,
  as = 'div',
  links = 'underline',
  tone = 'default',
  className,
}: RichTextProps) {
  if (!html) return null;

  return (
    <HtmlRendererRaw
      as={as}
      html={html}
      className={cn(
        'nt-rich nt-break-md [&_p]:m-0 [&_p]:[font:inherit]',
        links === 'brand' && 'nt-rich--brand',
        links === 'inherit' && 'nt-rich--inherit',
        tone === 'inverse' && 'nt-rich--inverse',
        variant,
        className,
      )}
    />
  );
}
